import { render, staticRenderFns } from "./auction.vue?vue&type=template&id=ea64dd84&scoped=true"
import script from "./auction.vue?vue&type=script&lang=js"
export * from "./auction.vue?vue&type=script&lang=js"
import style0 from "./auction.vue?vue&type=style&index=0&id=ea64dd84&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea64dd84",
  null
  
)

export default component.exports